import coverallCollection  from '../../assests/images/collections/coverall-collection-image.png';
import maskCollection  from '../../assests/images/collections/mask-collection-image.png';
import hatCollection  from '../../assests/images/collections/hats-collection-image.png';
import hiVisibilityCollection  from '../../assests/images/collections/high-visibility-clothing-collection-image.png';
import glassesCollection  from '../../assests/images/collections/glasses-collection-Image.png';
import glovesCollection  from '../../assests/images/collections/gloves-collection-image.png';
import bootsCollection  from '../../assests/images/collections/boots-collection-image.png';
import roadCollection  from '../../assests/images/collections/road-collection-image.png';

const productsCollection=[
    {
        image:bootsCollection,
        alt:"Boots Collection",
        name:'Boots',
        category:'Foot Protection'
    },
    {
        image:hiVisibilityCollection,
        alt:"Coverall Collection",
        name:'Coverall',
        category:'Body Protection'
    },
    {
        image:glassesCollection,
        alt:"Eyewear Collection",
        name:'Eyewear',
        category:'Eye Protection'
    },
    {
        image:glovesCollection,
        alt:"Gloves Collection",
        name:'Gloves',
        category:'Hand Protection'
    },
    {
        image:hatCollection,
        alt:"Hats Collection",
        name:'Hats',
        category:'Head Protection'
    },
    {
        image:maskCollection,
        alt:"Mask Collection",
        name:'Masks',
        category:'Breath Protection'
    },
    {
        image:roadCollection,
        alt:"Road Collection",
        name:'Road Safety',
        category:'Road Safety'
    }
]

export default productsCollection;